module.exports = __webpack_public_path__ + "static/LW_logo_employer_rgb-05b2f38f03da1c46e25aa6c07b65e223.svg";